module.exports = __webpack_public_path__ + "static/media/auth-bg.5a954da0.svg";